import React from 'react';

interface ITagProps {
	bgColor?: string;
	gradientColor?: { start: string; end: string };
	text?: string;
	textColor?: string;
	icon?: JSX.Element;
	subTag?: string;
}

export default function Tag({ bgColor, gradientColor, text, textColor, icon, subTag }: ITagProps) {
	const isValidIcon = icon && React.isValidElement(icon);
	return (
		<>
			{text && (
				<div
					className={`absolute ${subTag ? 'bottom-7' : 'bottom-0'} rounded-b-lg w-full font-bold text-sm leading-[14px] py-1 flex justify-center items-center gap-0.5 ${textColor || 'text-white'} ${
						bgColor ? bgColor : gradientColor && `bg-gradient-to-r ${gradientColor.start} ${gradientColor.end}`
					}`}>
					{isValidIcon && icon}
					{text}
				</div>
			)}
			{subTag && (
				<div
					className={`absolute bottom-0 rounded w-full font-bold text-sm leading-[14px] py-1 flex justify-center ${textColor || 'text-white'} ${
						bgColor ? bgColor : gradientColor && `bg-gradient-to-r ${gradientColor.start} ${gradientColor.end}`
					}`}>
					{subTag}
				</div>
			)}
		</>
	);
}
